import * as React from 'react';
import CaptureBillingAddress from '../components/CaptureBillingAddress';
import { Card, Box, Container, Typography, Alert } from '@mui/material';
import { useParams } from 'react-router-dom';
import { usePaymentContext } from '../context';
import { useRequestManager } from '../services';

type QueryParameters =
    {
        paymentId: string
    }

function BillingAddressPage() {
    const urlParams = useParams<QueryParameters>();

    const requestManager = useRequestManager();
    const paymentContext = usePaymentContext();

    React.useEffect(() => {
        if (urlParams.paymentId) {
            console.info('Loading payment request with ID', urlParams.paymentId);
            requestManager.loadRequest(urlParams.paymentId, false);
        }
    }, [urlParams.paymentId]);

    return <Box width={1}>
        {
            (paymentContext.paymentRequest) &&
            <Container maxWidth="md">
                {
                    (paymentContext.hasBillingAddressError) &&
                    <Box mb={3}>
                        <Alert severity="error">There appears to be an issue with the address details. Please check them and try again.</Alert>
                    </Box>
                }

                <Box>
                    <Typography variant="h2" gutterBottom>{paymentContext.paymentRequest.description}</Typography>
                    <Typography variant="h6" gutterBottom>To allow us to continue with your claim, you will need to make a payment of {paymentContext.paymentRequest.paymentValueAsString}</Typography>
                </Box>

                <Card>
                    <Box p={5} width={1}>
                        <Typography variant="h4" gutterBottom>Billing Address</Typography>
                        <CaptureBillingAddress />
                    </Box>
                </Card>
            </Container>
        }
    </Box>
}

export default BillingAddressPage;